import type { CarouselOptions } from '~/components/isolated/Carousel';

export const deliveryCarouselOpts: CarouselOptions = {
  align: 'start',
  slidesToScroll: 1,
  containScroll: 'trimSnaps',
  dragFree: true,
};
